import React, { Component } from 'react';
import { Grid, Input } from 'semantic-ui-react';
import { decamelize,JSONDisplayer } from './util';
//C:\zwork\KN-Component-Library-UI\src\components\qryFunc\util.js
//C:\zwork\KN-Component-Library-UI\src\components\qryFunc\responseSummary.js
import styled from "styled-components";
import _ from 'lodash';

export default class ResponseSummary extends Component {    
    constructor(props) {
        super(props);
        this.state = {
            "caseType": this.props.nonModalWindow?"CASE_0":null,
            openedList: {},
        }
    }
    onSearch = (e) => {
    }

    componentDidMount() {
    }

    render() {
        let colwidths ={
            statusName: 4,
            statusValue: 11,
            statusSeverity: 2,
        }
        let {qryOutput} =  this.props;
        let Iconcc = styled.span`
            & :hover {
                font-weight:bold;
            }
      `;
      


        console.log('qryOutput, hideDetails, loadEntrySummaryQueryState, nonModalWindow: ', qryOutput);
        if(!qryOutput.responseParams || !qryOutput.responseParams.advisoryInfos)return <div>No data found...</div>
        return (<div id='RSSOutput' className={`outputData adcvdOutput`}>
        <Grid  className={`primaryOutput`} columns={3} >
            <Grid.Row className={`selectcasebtn-row`} style={{flexWrap:'nowrap'}}>
                    <Grid.Column className={"keyName"} width={colwidths['statusName']}>
                        Name
                    </Grid.Column>
                    <Grid.Column className={"keyName"} width={colwidths['statusValue']}>
                    &nbsp;Message
                    </Grid.Column>
                    <Grid.Column className={"keyName"} width={colwidths['statusSeverity']}>
                        &nbsp;Severity
                    </Grid.Column>
                </Grid.Row>
           {
               qryOutput.responseParams.advisoryInfos && qryOutput.responseParams.advisoryInfos.map((item, index) => {
                let severityColor=(sevlevel)=>{
                    if(sevlevel==="STATUS_CODE_SUCCESS")return ' greenKX ';
                    if(sevlevel==="STATUS_CODE_WARNING")return ' redKX ';
                    if(sevlevel==="STATUS_CODE_NONE")return ' liteGrey ';
                }
                let toggler = ()=>{
                    let copyopenedList = this.state.openedList;
                    copyopenedList[item.statusName] = !copyopenedList[item.statusName];
                    this.setState({
                        openedList:copyopenedList
                    })
                };
                let toggledopen = this.state.openedList[item.statusName];
                return(<React.Fragment>
                    <Grid.Row key={item.statusName+"GGAWSEGWA"+index} className={`selectcasebtn-row`}  style={{flexWrap:'nowrap'}}
                >
                    <Grid.Column className={"keyName"} width={colwidths['statusName']}>
                            
                        <Iconcc >
                            <button onClick={toggler} style={{cursor: 'pointer'}}>
                                <i className={`blue ${toggledopen?"minus":"plus"} icon`} style={{float:'left'}}></i>
                            </button>
                            &nbsp;
                            <span style={{cursor:'pointer'}}
                                >
                                {(item.statusName+"").replaceAll(/ STATUS$/ig,"")}
                            </span>
                            
                        </Iconcc>
                    </Grid.Column>
                    <Grid.Column onClick={toggler} className={"keyName"} style={{fontWeight:'bold'}} width={colwidths['statusValue']} style={{height:'1rem',overflow:'hidden',cursor:'pointer',textOverflow:'ellipsis'}}>
                        &nbsp;{item.statusValue}
                    </Grid.Column>
                    <Grid.Column onClick={toggler} className={`keyName ${severityColor(item.statusSeverity)}`} width={colwidths['statusSeverity']} style={{height:'1rem',overflow:'hidden',cursor:'pointer',textOverflow:'ellipsis'}}>
                        &nbsp;{(item.statusSeverity+"").replaceAll("STATUS_CODE_","")}
                    </Grid.Column>
                </Grid.Row>
                {toggledopen && <React.Fragment><hr/>
                             {JSONDisplayer(item)}
                            </React.Fragment>}
                </React.Fragment>
               )})  
           }
       </Grid> 
   </div>)
    }
}